import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
import {CommonService} from '../common.service'
import {ApiService} from '../api.service';

@Component({
  selector: 'app-guide',
  templateUrl: './app-guide.component.html',
  styleUrls: ['./app-guide.component.css']
})
export class AppGuideComponent implements OnInit , AfterViewInit{
  @Input() pageLoaded: boolean;

  @Output() outPutMenuClick = new EventEmitter<any>();
  @Output() outPutToolsClick = new EventEmitter<any>();

  isShowItem: boolean = false;
  step: number;
  haveExerciseBook:boolean;
  isScorm : boolean = false;//从LMS平台隐藏引导
  rem: number = 50;

  constructor(
    private commonService: CommonService,
    private apiService: ApiService
  ) { }

  ngOnInit(){
    this.step = 0;
  }


  ngAfterViewInit(){
    if(this.pageLoaded){
      setTimeout(()=>{
        this.haveExerciseBook = !!localStorage.getItem('haveExerciseBook');
        this.isShowItem = true;
      },1000);
    }
    if(localStorage.getItem("source_env") === "LMS_SCORM"){
      this.isScorm = true;
    }
  }

  //设置工具icon引导位置，根据工具栏的tab高度来设置
  setToolIconTop(){
    let toolEle = document.getElementById('app-tools') as HTMLElement;
    let tootlEleTop = toolEle ? toolEle.getBoundingClientRect().top / this.rem : 0;
    let guideEle = document.getElementById('guide_tools' + this.step) as HTMLElement;
    guideEle.style.top = tootlEleTop + 'rem';

    console.log('tootlEleTop',tootlEleTop);
    let guide_hand_text = document.getElementById('guide_hand_text') as HTMLElement;
    guide_hand_text.style.top = ((tootlEleTop + 0.5) + 'rem');
  }

  /**
   * 点击menu
   */
  clickMenu():void{
    let that = this;
    that.step = 1;
    that.outPutMenuClick.emit()
    setTimeout(()=>{
      that.setToolIconTop();
    },100)
  }

  /**
   * 进入工具
   */
  goTools():void{
    this.commonService.setOnceIno(99999).subscribe(()=>{
      this.outPutToolsClick.emit();
    })
  }

  /**
   *校验用户是否有小工具权限
   */
  getUserHaveTools():Promise<any>{
    return this.apiService.ajax({
      'type': 'GET',
      'url':'/sr/tools/yyToolsLibrary/haveToolsAuthority'
    }).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/app-guide/app-guide.component.ts